import { createRoute } from '@tanstack/react-router'
import { Route as settingsLayoutRoute } from './layout'

export const Route = createRoute({
  getParentRoute: () => settingsLayoutRoute,
  path: '/settings/learn',
}).lazy(() => import('./learn.lazy').then((d) => d.Route))
